import { Component, inject, input, signal } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { PhoneDto } from '../../../shared/Models/PhoneDto';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CaseDto } from '../../../shared/Models/CaseDto';
import { OrderContactStore } from '../order-contact.store';
import { LoadingSpinnerSelectComponent } from '../../../shared/Components/loading-spinner-select/loading-spinner-select.component';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'debtor-panel-order-contact-data-input',
  templateUrl: './order-contact-data-input.component.html',
  styleUrls: ['./order-contact-data-input.component.scss'],
  imports: [
    TranslateModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatCheckboxModule,
    MatTimepickerModule, MatDatepickerModule, MatNativeDateModule, MatSelectModule,
    LoadingSpinnerSelectComponent, DecimalPipe,
  ],
})
export class OrderContactDataInputComponent {
  protected store = inject(OrderContactStore);
  public phoneNumbers = input<PhoneDto[]>();
  public cases = input<CaseDto[]>();
  public formGroup = input.required<FormGroup>();
  public minHour = signal(this.store.getMinOpenHours());

  readonly minDate = new Date();
  readonly maxDate = this.store.getMaxCallbackDays();

  protected myDateFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    const getHour = new Date().getHours();
    const getMin = new Date().getMinutes();
    const getSec = new Date().getSeconds();
    const maxHour = this.store.getMaxOpenHours();
    if(maxHour) {
      const time1Parts = maxHour.split(':');
      if(time1Parts.length === 3 && ((getHour + 1) > Number(time1Parts[0])
        || (getHour + 1 === Number(time1Parts[0]) && getMin > Number(time1Parts[1]))
        || (getHour + 1 === Number(time1Parts[0]) && getMin === Number(time1Parts[1]) && getSec > Number(time1Parts[2])))
      ) {
        return day !== 0 && day !== 6 && d?.getDay() !== new Date().getDay();
      }
    }

    return day !== 0 && day !== 6;
  };

  protected changeDate(): void {
    const chosenDate = this.formGroup().get('date');
    if(!chosenDate?.valid || !chosenDate.value) {
      this.formGroup().get('hour')?.disable();
    }
    else {
      const today = new Date().getDate();
      const minHour = this.store.getMinOpenHours();
      if(chosenDate.value.getDate() === today && minHour) {
        const time1Parts = minHour.split(':');
        const newDate = new Date();
        newDate.setHours(newDate.getHours() + 1);
        if(newDate.getHours() > Number(time1Parts[0]) || (newDate.getHours() === Number(time1Parts[0]) && newDate.getMinutes() > Number(time1Parts[1]))) {
          this.minHour.set(newDate.toLocaleString('pl-PL', { hour: 'numeric', minute: 'numeric' }));
        }
        else {
          newDate.setHours(Number(time1Parts[0]));
          newDate.setMinutes(Number(time1Parts[1]));
          newDate.setSeconds(Number(time1Parts[2]));
          this.minHour.set(newDate.toLocaleString('pl-PL', { hour: 'numeric', minute: 'numeric' }));
        }
      } else {
        this.minHour.set(this.store.getMinOpenHours());
      }
      this.formGroup().get('hour')?.enable();
    }
  }

  protected checkboxToggle(checkboxChange: MatCheckboxChange): void {
    if(checkboxChange.checked) {
      const date = this.formGroup().get('date');
      const hour = this.formGroup().get('hour');
      date?.patchValue('');
      hour?.patchValue('');
      date?.disable();
      hour?.disable();
    } else {
      this.formGroup().get('date')?.enable();
    }
  }
}
